import { getDecodedToken } from "./localStorage";
import { getPediaDoctorDetails } from "../pages/account/service";

/**
 * Get b2c_id with fallback strategies for DDx functionality
 * Handles cases where b2c_id is missing from localStorage
 */
export const getB2cIdWithFallbacks = async (): Promise<string> => {
  let b2cId = localStorage.getItem("b2c_id");
  if (b2cId) {
    return b2cId;
  }
  const tokenData: any = getDecodedToken();
  if (tokenData?.user?.b2cId) {
    b2cId = tokenData.user.b2cId;
    if (b2cId) {
      localStorage.setItem("b2c_id", b2cId);
      return b2cId;
    }
  }
  if (tokenData?.user?.mobileNumber) {
    try {
      const res: any = await getPediaDoctorDetails(tokenData.user.mobileNumber);
      if (res?.status === 200 && res?.data?.body?.b2c_id) {
        b2cId = res.data.body.b2c_id;
        if (b2cId) {
          localStorage.setItem("b2c_id", b2cId);
          return b2cId;
        }
      }
    } catch (error) {
      console.error("Failed to get b2c_id from API:", error);
    }
  }
  console.warn("Could not retrieve b2c_id through any fallback method");
  return "";
};
export const getB2cIdSync = (): string => {
  let b2cId = localStorage.getItem("b2c_id");
  if (b2cId) {
    return b2cId;
  }
  const tokenData: any = getDecodedToken();
  if (tokenData?.user?.b2cId) {
    b2cId = tokenData.user.b2cId;
    if (b2cId) {
      localStorage.setItem("b2c_id", b2cId);
      return b2cId;
    }
  }
  return "";
};
